// prettier-ignore
import * as fcl from "@onflow/fcl"
import {tx} from "./util/tx"
import BUY_TRANSACTION from "./cadence/transactions/buy.cdc"
import {UFix64} from "@onflow/types"

export async function buy(amount, opts = {}) {
    // prettier-ignore
    return tx(
        {
            cadence: BUY_TRANSACTION,
            limit: 9999,
            args: (arg, t) => [ fcl.arg(amount.toFixed(2), UFix64) ]
        },
        opts
    )
}
